module.exports = __webpack_public_path__ + "public/SiteImages/noListImage.svg?dcc78e74";